import React from "react";

export function AvailableLoanOptionButton(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="31.5 0 28.93 38.22"
      width="30"
      height="30"
      {...props}
    >
      <g id="icons">
        <g id="available_loan_options" data-name="available loan options">
          <path
            className="available-loan-option-path"
            d="m 60.43 38.21 h -28.93 v -38.21 h 22.81 l 6.12 6.55 v 31.67 z m -27.43 -0.51 h 27 v -30.6 l -5.8 -6.6 h -22.34 v 37.2 z"
          />
          <path
            className="filled-loan-option-path"
            d="m 60.43 38.21 h -28.93 v -38.21 h 22.81 l 6.12 6.55 v 31.67 z z"
          />
        </g>
      </g>
    </svg>
  );
}
